import styled from 'styled-components';

import { Text16 } from '@sorare/core/src/atoms/typography';

export const SectionTitle = styled(Text16)`
  font-weight: var(--t-bold);
`;
